export default process.env.NEXT_PUBLIC_API_URL || 'https://api.mmhmm.app'
